import {API_BASE} from '../apiConfig';

// Чем закончилась попытка встать в поиск рейтингового матча (кнопка
// «Рейтинговый матч»). Вынесено из App.js отдельной функцией: раньше любой
// неразобранный отказ сервера только писался в консоль, и кнопка для игрока
// просто «не работала»
export const RANK_MATCH_JOIN_OUTCOMES = {
  // Игрок в поиске: открываем экран ожидания
  WAITING: 'WAITING',
  // Игрок уже состоит в лобби (в т.ч. собранном матчмейкингом) — идем туда
  LOBBY: 'LOBBY',
  // Для рейтинга нужно минимум четыре открытые фракции
  NOT_ENOUGH_FACTIONS: 'NOT_ENOUGH_FACTIONS',
  // Сеть, таймаут или неожиданный ответ сервера — игроку нужно это показать
  FAILED: 'FAILED',
};

// Отказ сервера до появления перехвата поиска (см. /api/rank-match/join):
// запись игрока в пуле числилась живой — чаще всего после молчаливого обрыва
// сети, когда сервер еще не заметил, что старый сокет ожидания мертв
export const RANK_MATCH_ALREADY_WAITING_ERROR = 'Player is already waiting for a rank match';

// Сервер отвечает за доли секунды; дольше — связь, скорее всего, пропала, и
// висящий запрос не должен навсегда глотать нажатия кнопки
export const RANK_MATCH_JOIN_TIMEOUT_MS = 15000;

export const resolveRankMatchJoinOutcome = (response, data = {}) => {
  if (response.ok) {
    return {
      kind: RANK_MATCH_JOIN_OUTCOMES.WAITING,
      opponentCounts: Array.isArray(data.opponentCounts) ? data.opponentCounts : null,
      searchId: data.searchId || null,
    };
  }

  if (data.error === 'NOT_ENOUGH_FACTIONS') {
    return {kind: RANK_MATCH_JOIN_OUTCOMES.NOT_ENOUGH_FACTIONS, availableCount: data.availableCount || 0};
  }

  if (data.error === 'Player is already in another lobby' && data.lobbyId) {
    return {kind: RANK_MATCH_JOIN_OUTCOMES.LOBBY, lobbyId: data.lobbyId};
  }

  // Поиск уже идет: экран ожидания все равно его подхватит — сервер цепляет
  // новый сокет ожидания к существующей записи вместо старого
  if (response.status === 409 && data.error === RANK_MATCH_ALREADY_WAITING_ERROR) {
    return {kind: RANK_MATCH_JOIN_OUTCOMES.WAITING, opponentCounts: null, searchId: null};
  }

  return {kind: RANK_MATCH_JOIN_OUTCOMES.FAILED, reason: `http_${response.status}`};
};

/**
 * POST /api/rank-match/join с таймаутом. Никогда не бросает: сбой сети и
 * таймаут — это исход FAILED с reason 'network' / 'timeout'.
 *
 * opponentCounts — выбор ограничения с экрана настройки поиска: сервер
 * применит и сохранит именно его. Без него (повторный вход экрана поиска после
 * обрыва) сервер берет сохраненное в профиле
 */
export const requestRankMatchJoin = async ({
  playerName,
  playerId,
  opponentCounts,
  fetchImpl = fetch,
  timeoutMs = RANK_MATCH_JOIN_TIMEOUT_MS,
}) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetchImpl(`${API_BASE}/rank-match/join`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(
        Array.isArray(opponentCounts) ? {playerName, playerId, opponentCounts} : {playerName, playerId}
      ),
      signal: controller.signal,
    });
    const data = await response.json().catch(() => ({}));
    return resolveRankMatchJoinOutcome(response, data);
  } catch (error) {
    return {
      kind: RANK_MATCH_JOIN_OUTCOMES.FAILED,
      reason: controller.signal.aborted ? 'timeout' : 'network',
    };
  } finally {
    clearTimeout(timeoutId);
  }
};
